/**
 * Условия банков, которые известны заранее и проверяются до отправки заявки.
 *
 * Зачем: за неделю Freedom отказал 305 заявкам из 937 по взносу и сроку —
 * больше, чем одобрил (65). Менеджер узнаёт об этом через полчаса из карточки,
 * хотя условие известно в момент ввода. На сроках 36, 48 и 24 отказ приходит
 * почти всегда (45 из 48, 37 из 40, 19 из 23), на 60/72/84 отказов по сроку нет.
 *
 * Это подсказка, а не запрет: условия банков меняются, бывают акции и ручные
 * договорённости. Менеджер видит предупреждение и решает сам.
 *
 * Пока здесь только Freedom — условий остальных банков у нас нет. Когда появятся,
 * их место здесь же, а не в разметке формы.
 */

export const FREEDOM_BANK_ID = 3;

/** Freedom Bank, условия на 11.10.2026 (со слов банка). */
export const FREEDOM_CONDITIONS = {
  name: 'Freedom Bank',
  minInitialFeePercent: 10,
  maxInitialFeePercent: 40,
  periods: [60, 72, 84],
};

const toNumber = (value) => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string') return null;
  const digits = value.replace(/\s/g, '').replace(',', '.');
  if (digits === '') return null;
  const parsed = Number(digits);
  return Number.isFinite(parsed) ? parsed : null;
};

/** Разряды пробелом. toLocaleString в разных окружениях ставит неразрывный. */
const withSpaces = (value) => String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

/**
 * Подходит ли первоначальный взнос под условия Freedom.
 * null — проверить нельзя (нет цены или взноса), предупреждение не показываем.
 */
export const freedomInitialFeeWarning = (initialFee, carPrice) => {
  const fee = toNumber(initialFee);
  const price = toNumber(carPrice);
  if (fee === null || price === null || price <= 0) return null;

  const percent = (fee / price) * 100;
  const { minInitialFeePercent: min, maxInitialFeePercent: max, name } = FREEDOM_CONDITIONS;

  // Округляем так же, как видит менеджер: 9,6% — это «меньше 10».
  const shown = Math.round(percent);
  if (percent < min) {
    const needed = withSpaces(Math.ceil((price * min) / 100));
    return `${name} откажет: взнос ${shown}% — банк принимает от ${min}% (${needed} ₸).`;
  }
  if (percent > max) {
    return `${name} откажет: взнос ${shown}% — банк принимает до ${max}%.`;
  }
  return null;
};

/** Подходит ли срок кредитования под условия Freedom. */
export const freedomPeriodWarning = (period) => {
  const months = toNumber(period?.value ?? period);
  if (months === null) return null;

  const { periods, name } = FREEDOM_CONDITIONS;
  if (periods.includes(months)) return null;
  return `${name} откажет: срок ${months} мес — банк принимает ${periods.join(', ')}.`;
};
